import * as FwDatas from "../../FwDatas.ts";
import * as i18n from "../../i18n.ts";

/**
 * The shape a bean must have to receive ISharableByMemberProto.
 * Beans declare the added methods themselves, through a `declare module "../fizapilib.auto.ts"` block.
 */
export interface ISharableByMember {
  sharedToAll?: boolean;
  sharedMemberIds?: number[];
  sharedMembers(): any[];
}

//if we do $.extend({},aTruePrototype) it does not work, so we build a fake proto
const ISharableByMemberProto = {
  isShared(this: ISharableByMember): boolean {
    return this.sharedToAll || (this.sharedMemberIds && this.sharedMemberIds.length>1);
  },
  sharedMembers(this: ISharableByMember): any[] {
    var
      result: any[] = [],
      members = FwDatas.getFamily().members,
      sharedIds = this.sharedMemberIds||[],
      sharedToAll = this.sharedToAll;
    members.forEach(function(member: any){
      if(member.isloggedaccount){
        return;
      }
      function MemberSharedView(this: any, shared: boolean){
        this.shared=shared;
      }
      MemberSharedView.prototype=member;
      result.push(new (MemberSharedView as any)(sharedToAll || sharedIds.indexOf(member.accountId)!==-1));
    });
    return result;
  },
  sharedCartridge(this: ISharableByMember, onclick: string): string {
    const
      sharedProfiles = this.sharedMembers(),
      title = i18n.get('sharingtooltip',sharedProfiles.length - 1); //-1 because we do not count ourselves

    return `<span class="shared-card" data-fw-onclick="${onclick}" titlehtml="${title}">
    ${sharedProfiles.map((profile: any)=>`<span><img src="${profile.thumb()}"/></span>`).join('')}
    <span>${sharedProfiles.length}</span>
</span>`

  }
}

export default ISharableByMemberProto;
